import { Tag } from 'antd';
import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  padding: 76px 24px 32px 250px;
  background: radial-gradient(circle at top left, rgba(37, 99, 235, 0.08), transparent 24%), linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%);
  overflow: auto;

  @media only screen and (max-width: 1024px) {
    padding: 72px 14px 24px;
    width: 100%;
  }
`;

export const ActionBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 18px;

  @media only screen and (max-width: 900px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const ActionsGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px;

  @media only screen and (max-width: 900px) {
    justify-content: stretch;
  }
`;

export const OrderTitle = styled.section`
  min-width: 0;
  padding: 22px;
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 18px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.98), rgba(248, 250, 252, 0.96));
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.05);

  @media only screen and (max-width: 768px) {
    padding: 18px;
  }
`;

export const HeaderMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const StatusRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
`;

export const OrderContainer = styled.section`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 16px;
  width: 100%;
  margin-top: 18px;
`;

export const OrderArea = styled.article`
  min-width: 0;
  padding: 22px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid rgba(148, 163, 184, 0.22);
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.05);
`;

export const OrderAreaProducts = styled.section`
  width: 100%;
  min-width: 0;
  margin-top: 18px;
  /* padding: 22px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid rgba(148, 163, 184, 0.22);
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.05); */
`;

export const CustomDivider = styled.div`
  height: 1px;
  margin: 18px 0;
  background: linear-gradient(90deg, rgba(203, 213, 225, 0.9), rgba(226, 232, 240, 0.35));
`;

export const OrderSummary = styled.div`
  div {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    padding: 9px 0;
    border-bottom: 1px solid rgba(226, 232, 240, 0.8);

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }

    span:first-child {
      color: #64748b;
      font-size: 13px;
      font-weight: 600;
      letter-spacing: 0.02em;
      text-transform: uppercase;
    }

    span:last-child {
      color: #0f172a;
      font-weight: 600;
      text-align: right;
    }
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;

  @media only screen and (max-width: 900px) {
    flex-direction: column;
  }
`;

export const SectionHeaderInline = styled.div`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 16px;
  margin-bottom: 18px;

  @media only screen and (max-width: 1100px) {
    grid-template-columns: 1fr;
    align-items: flex-start;
  }
`;

export const SectionHeading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const TableScroll = styled.div`
  width: 100%;
  overflow-x: auto;
`;

export const ProductsTable = styled.table`
  width: 100%;
  min-width: 1150px;
  border-collapse: separate;
  border-spacing: 0;
  margin-top: 8px;
  overflow: hidden;
  border: 1px solid rgba(226, 232, 240, 0.95);
  border-radius: 14px;
  background: #fff;

  th {
    padding: 14px 16px;
    background: #f8fafc;
    color: #475569;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    border-bottom: 1px solid rgba(226, 232, 240, 0.95);
  }

  tr {
    td,
    th {
      text-align: center;
    }
  }

  td {
    padding: 14px 16px;
    color: #0f172a;
    border-bottom: 1px solid rgba(241, 245, 249, 1);
  }

  tbody tr:nth-child(even) {
    background: rgba(248, 250, 252, 0.9);
  }

  tbody tr:hover {
    background: rgba(226, 232, 240, 0.55);
  }

  tbody tr:last-child td {
    border-bottom: none;
  }

  tbody td:first-child,
  thead th:first-child {
    text-align: left;
  }
`;

export const SearchProducts = styled.section`
  width: 100%;
  padding: 22px;
  margin-top: 18px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid rgba(148, 163, 184, 0.22);
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.05);
`;

export const FormRow = styled.div`
  display: grid;
  grid-template-columns: minmax(320px, 1.6fr) minmax(120px, 160px) minmax(220px, 1fr) auto;
  gap: 12px;
  align-items: start;
  margin-top: 18px;

  @media only screen and (max-width: 1100px) {
    grid-template-columns: 1fr;
  }

  .ant-form-item {
    margin-bottom: 0;
  }
`;

export const ProductsTableShipped = styled.table`
  width: 100%;
  min-width: 900px;
  border-collapse: separate;
  border-spacing: 0;
  margin-top: 8px;
  border: 1px solid rgba(226, 232, 240, 0.95);
  border-radius: 14px;
  background: #fff;

  th {
    padding: 14px 16px;
    background: #f8fafc;
    color: #475569;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    border-bottom: 1px solid rgba(226, 232, 240, 0.95);
  }

  tr {
    td,
    th {
      text-align: center;
    }
  }

  td {
    padding: 14px 16px;
    color: #0f172a;
    border-bottom: 1px solid rgba(241, 245, 249, 1);
  }

  tbody tr:nth-child(even) {
    background: rgba(248, 250, 252, 0.9);
  }

  tbody tr:hover {
    background: rgba(226, 232, 240, 0.55);
  }

  tbody tr:last-child td {
    border-bottom: none;
  }
`;

export const ComponentTextArea = styled.textarea`
  width: 100%;
  min-height: 116px;
  resize: vertical;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid rgba(203, 213, 225, 1);
  background: #fff;
  color: #0f172a;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;

  &:focus {
    outline: none;
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
  }
`;

export const TrackingLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 999px;
  background-color: #f8fafc;
  color: #1e293b;
  text-decoration: none;
  border: 1px solid #e2e8f0;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f1f5f9;
    border-color: #cbd5e1;
  }
`;

export const LinkIcon = styled.span`
  font-size: 12px;
  color: #64748b;
`;

export const StyledIcon = styled.img`
  width: 20px;
  height: 20px;
  object-fit: contain;
`;

export const StoreIdentity = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 2px;
  padding: 6px 10px;
  border-radius: 999px;
  border: 1px solid rgba(203, 213, 225, 0.8);
  background: rgba(248, 250, 252, 0.95);
`;

export const StoreIcon = styled(StyledIcon)`
  width: 16px;
  height: 16px;
`;

export const StoreNameText = styled.span`
  color: #475569;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
`;

export const WarningCallout = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-width: 0;
  width: 100%;
  max-width: 100%;
  padding: 10px 14px;
  border-radius: 999px;
  border: 1px solid rgba(245, 158, 11, 0.28);
  background: linear-gradient(135deg, rgba(255, 251, 235, 0.98), rgba(254, 243, 199, 0.9));
  box-shadow: 0 12px 24px rgba(245, 158, 11, 0.12);
  white-space: nowrap;
  overflow: hidden;

  @media only screen and (max-width: 1100px) {
    justify-content: flex-start;
    white-space: normal;
    border-radius: 16px;
  }
`;

export const WarningIconWrap = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  border-radius: 999px;
  background: rgba(245, 158, 11, 0.14);
  color: #b45309;
  font-size: 13px;
`;

export const WarningContent = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
`;

export const WarningTitle = styled.span`
  color: #92400e;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
`;

export const WarningText = styled.span`
  color: #78350f;
  font-size: 13px;
  line-height: 1.2;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media only screen and (max-width: 1100px) {
    white-space: normal;
  }
`;

export const StyledTag = styled(Tag)`
  && {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    height: 36px;
    border-radius: 999px;
    border: 1px solid #e2e8f0;
    color: #1e293b;
    font-size: 14px;
    font-weight: 500;
    line-height: 1;
    transition: all 0.2s ease;
    margin-inline-end: 0;

    &:hover {
      opacity: 0.9;
    }
  }
`;
